import { createContext, useContext } from "react";
import { useWindowSize } from "./useWindowSize.js";
const ContainerWidthContext = createContext(void 0);
ContainerWidthContext.displayName = "ContainerWidthContext";
function useContainerWidth() {
  const maybeContainerWidth = useContext(ContainerWidthContext);
  const { width: windowWidth } = useWindowSize();
  return maybeContainerWidth ?? windowWidth;
}
export {
  ContainerWidthContext,
  useContainerWidth
};
//# sourceMappingURL=useContainerWidth.js.map
